import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Screen } from '../../components/Screen'; // Adjust the import path as needed
import {
  getContentfulArticleCards,
  getContentfulRecipeCardCards,
  getContentfulRecipeCards,
  getContentfulVideoCards,
} from '../../lib/contentful/getContentfulContent';
import { DetailView } from './components/DetailView';
import { FilterableView } from './components/FilterableView';
import { LearningCenterCategories } from './components/LearningCenterCategories';
import {
  getCategoryMetaByPath,
  getCategoryBaseUrlByPath,
  LEARNING_CENTER_CATEGORIES,
} from '../../lib/constants/learningCenterMeta';

const LearningCenterScreen = () => {
  // Fetched content grouped by category path
  const [contentData, setContentData] = useState({});
  const params = useParams();
  const location = useLocation();
  const categoriesKeys = Object.values(LEARNING_CENTER_CATEGORIES)
    .filter((c) => c.key !== 'guidebooks')
    .map((c) => c.key);

  useEffect(() => {
    let isMounted = true;

    const fetchers = {
      articles: getContentfulArticleCards,
      recipe_cards: getContentfulRecipeCardCards,
      recipes: getContentfulRecipeCards,
      videos: getContentfulVideoCards,
      // guidebooks can be added when available
    };

    const load = async () => {
      const results = await Promise.all(
        Object.entries(fetchers).map(async ([path, fn]) => {
          try {
            const data = await fn();
            return [path, data];
          } catch (e) {
            console.error(e);
            return [path, []];
          }
        }),
      );
      if (!isMounted) return;
      const next = results.reduce((acc, [path, data]) => {
        acc[path] = data;
        return acc;
      }, {});
      setContentData((prev) => ({ ...prev, ...next }));
    };

    load();
    return () => {
      isMounted = false;
    };
  }, []);

  if (params.slug && params.category) {
    const meta = getCategoryMetaByPath(params.category);
    if (meta) {
      return (
        <DetailView
          type={meta.detailType || params.category}
          slug={params.slug}
        />
      );
    }
  }

  const categoryPaths = Object.keys(LEARNING_CENTER_CATEGORIES);
  const matchedPath = categoryPaths.find((p) => location.pathname === getCategoryBaseUrlByPath(p));
  if (matchedPath) {
    const meta = getCategoryMetaByPath(matchedPath);
    return (
      <Screen
        title={meta.title}
        showSidebarNav={true}
        admin={true}
      >
        <FilterableView
          title={meta.title}
          viewAllPath={getCategoryBaseUrlByPath(matchedPath)}
          data={contentData[matchedPath] || []}
        />
      </Screen>
    );
  }

  // Default display if no specific viewAllPath is active
  return (
    <Screen
      title={'Learning Center'}
      showSidebarNav={true}
      admin={true}
    >
      <Box sx={{ padding: '30px' }}>
        <LearningCenterCategories
          categoriesKeys={categoriesKeys}
          limit={4}
        />
      </Box>
    </Screen>
  );
};

export default LearningCenterScreen;
